import {Box, Card, FormControl, IconButton, MenuItem, Select, TextField, Typography} from "@mui/material";
import {COLORS} from "../../../ui/Theme";
import {Add, Close} from '@mui/icons-material';
import {useOptionCalculator} from "../../../context/derivatives/calculator/OptionCalculatorContext";
import {toast} from "react-toastify";
import Grid2 from "@mui/material/Unstable_Grid2";

const optionLabels = {
    buy: "خرید",
    sell: "فروش",
    call: "اختیار خرید",
    put: "اختیار فروش",
    stock: "سهام",
};

const OptionCalculatorPositions = () => {

    const {state, setState} = useOptionCalculator()

    const handleChange = (index, field) => (event) => {
        const value = event.target.value;
        setState((prevState) =>
            prevState.map((position, idx) =>
                idx === index ? {...position, [field]: value} : position
            )
        );
    };

    // remove row
    const handleRemove = (index) => {
        if (state.length === 1) {
            toast.warn("شما نمی‌توانید آخرین پوزیشن را حذف کنید!")
            return;
        }
        setState((prevState) => prevState.filter((_, idx) => idx !== index));
    };

    // add row
    const handleAddPosition = () => {
        setState((prevState) => [
            ...prevState,
            {buy_sell: "", call_put_stock: "", strike: "", premium: ""},
        ]);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                padding: "20px",
            }}
        >
            <Typography sx={{color: COLORS.BLACK, fontSize: "16px", fontWeight: 700}}>
                ماشین حساب
            </Typography>

            {state.map((position, index) => (
                <Card
                    key={index}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "20px",
                    }}
                >
                    <Grid2 container spacing={2} width="100%">
                        <Grid2 xs={12} lg={0.5} sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: {xs: "flex-start", lg: "center"}
                        }}>
                            {/*remove row*/}
                            {state.length > 1 && (
                                <IconButton onClick={() => handleRemove(index)}>
                                    <Close sx={{color: COLORS.RED}}/>
                                </IconButton>
                            )}
                        </Grid2>
                        <Grid2 xs={12} md={6} lg={2.875}>
                            {/* خرید / فروش (Buy/Sell) */}
                            <FormControl fullWidth>
                                <Select
                                    value={position.buy_sell}
                                    onChange={handleChange(index, "buy_sell")}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return (
                                                <Typography sx={{fontSize: "12px", color: "#9E9E9E"}}>
                                                    خرید / فروش
                                                </Typography>
                                            );
                                        }
                                        return (
                                            <Typography sx={{fontSize: "12px"}}>
                                                {optionLabels[selected]}
                                            </Typography>
                                        );
                                    }}
                                >
                                    <MenuItem value="buy">خرید</MenuItem>
                                    <MenuItem value="sell">فروش</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid2>
                        <Grid2 xs={12} md={6} lg={2.875}>
                            {/* نوع اوراق (Call / Put / Stock) */}
                            <FormControl fullWidth>
                                <Select
                                    value={position.call_put_stock}
                                    onChange={handleChange(index, "call_put_stock")}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return (
                                                <Typography sx={{fontSize: "12px", color: "#9E9E9E"}}>
                                                    نوع اوراق
                                                </Typography>
                                            );
                                        }
                                        return (
                                            <Typography sx={{fontSize: "12px"}}>
                                                {optionLabels[selected]}
                                            </Typography>
                                        );
                                    }}
                                >
                                    <MenuItem value="call">اختیار خرید</MenuItem>
                                    <MenuItem value="put">اختیار فروش</MenuItem>
                                    <MenuItem disabled={position.buy_sell === "sell"} value="stock">سهام</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid2>
                        <Grid2 xs={12} md={6} lg={2.875}>
                            {/* قیمت اعمال (Strike) */}
                            <TextField
                                value={position.strike}
                                onChange={handleChange(index, "strike")}
                                type="number"
                                placeholder="قیمت اعمال"
                                inputProps={{min: 1}}
                                disabled={position.call_put_stock === "stock"}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={6} lg={2.875}>
                            {/* قیمت (Premium) */}
                            <TextField
                                value={position.premium}
                                onChange={handleChange(index, "premium")}
                                type="number"
                                placeholder="قیمت"
                                inputProps={{min: 1}}
                            />
                        </Grid2>
                    </Grid2>
                </Card>
            ))}

            {/* Add Position Button */}
            <Box>
                <button
                    className="btn btn-softblue"
                    style={{width: "fit-content"}}
                    onClick={handleAddPosition}
                >
                    افزودن پوزیشن <Add/>
                </button>
            </Box>
        </Box>
    );
};

export default OptionCalculatorPositions;